/**
 * Exports data to CSV format
 * @param data Array of objects to export
 * @param filename Name of the file to download
 */
export function exportToCSV(data: any[], filename: string) {
  if (!data || !data.length) {
    console.error("No data to export")
    return
  }

  // Get headers from the first object
  const headers = Object.keys(data[0])

  // Create CSV content
  const csvContent = [
    // Headers row
    headers.join(","),
    // Data rows
    ...data.map((row) =>
      headers
        .map((header) => {
          // Handle values that might contain commas or quotes
          const value = row[header]
          const valueStr = value === null || value === undefined ? "" : String(value)
          // Escape quotes and wrap in quotes if contains comma or quote
          if (valueStr.includes(",") || valueStr.includes('"')) {
            return `"${valueStr.replace(/"/g, '""')}"`
          }
          return valueStr
        })
        .join(","),
    ),
  ].join("\n")

  // Create a blob and download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.setAttribute("href", url)
  link.setAttribute("download", `${filename}.csv`)
  link.style.visibility = "hidden"
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Exports data to JSON format
 * @param data Data to export
 * @param filename Name of the file to download
 */
export function exportToJSON(data: any, filename: string) {
  const jsonContent = JSON.stringify(data, null, 2)
  const blob = new Blob([jsonContent], { type: "application/json" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.setAttribute("href", url)
  link.setAttribute("download", `${filename}.json`)
  link.style.visibility = "hidden"
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Exports data to Excel format (actually CSV with .xlsx extension)
 * @param data Array of objects to export
 * @param filename Name of the file to download
 */
export function exportToExcel(data: any[], filename: string) {
  // For a proper Excel export, you would typically use a library like xlsx
  // This is a simplified version that creates a CSV with Excel extension
  exportToCSV(data, filename.replace(/\.xlsx$/, "") + ".xlsx")
}
